// extracted by mini-css-extract-plugin
export default {"or":"express-payments_or__7d9da","expressPayments":"express-payments_expressPayments__2f33d"};